<template>
    <section id="rmsscookiepolicy">
        <div>
        </div>
    </section>

    <div class="container rmsscookiepolicy-container">

    <h1 id="rmsoftwareservicesltdcookiepolicy">RM Software Services Ltd cookie policy</h1>

    <p>We use cookies on our website. You’ll find a notice about this on our homepage as well, which also links back to this policy.</p>

    <p>If you use this website after we’ve displayed the notice to you, we will treat this as your consent to our use of cookies for the purposes that we’ve explained below in our policy.</p>

    <p>We last updated our policy on 2 November 2019.</p>

    <h2 id="1informationaboutcookies">1. Information About Cookies</h2>

    <p>A cookie is a small text file which is placed onto your computer (or other electronic device) when you access our website.</p>

    <p>There are 4 different types of cookies:</p>

    <ol>
    <li><p>Strictly-necessary cookies (required for the website to run). These allow you to do things like log in securely.</p></li>

    <li><p>Performance cookies (which measure how many visitors use our site, which pages they visit and how they interact with the site). These help us to improve our website.</p></li>

    <li><p>Functionality cookies (which remember specific visitor’s preferences for the way they use our site, e.g. language settings or font size).</p></li>

    <li><p>Targeting/advertising cookies (these collect information about individual visitors that enable us, or third parties, to provide relevant advertisements to those who have visited our site)</p></li>
    </ol>

    <p>Our website may use each type of them in order to:</p>

    <ol>
    <li><p>make your online experience more efficient and enjoyable</p></li>

    <li><p>improve our services</p></li>

    <li><p>recognise you whenever you visit this website and distinguish you from other users of our site</p></li>

    <li><p>obtain information about your preferences and use of our site</p></li>

    <li><p>provide you with advertising which is tailored to your interests</p></li>

    <li><p>carry out research and data analysis to help us to improve our content and services and to better understand our customer preferences and interests.</p></li>

    <li><p>Your web browser places cookies on your hard drive for record-keeping purposes and sometimes to track information about you.</p></li>
    </ol>

    <p>We have set out specific details of the cookies we use on our site in section 4 below.</p>

    <h2 id="2thirdpartycookies">2. Third party cookies</h2>

    <p>Like many other websites, third-parties may also set cookies on our website. These third-parties are responsible for the cookies they set on our site and we have no control over them. For further information on how their cookies policies work, please visit their websites.</p>

    <h2 id="3managingcookies">3. Managing Cookies</h2>

    <p>You can manage cookies yourself.</p>

    <p>You can set your web browser to refuse cookies, delete cookies, or to alert you when cookies are being sent.</p>

    <p>You will need to visit the web browser’s site to learn how to manage cookies.</p>

    <p>For further information about cookies and how to manage or disable them please go to: www.aboutcookies.org.</p>

    <p>Please also note that if you change/block cookies then:</p>

    <ul>
    <li><p>some parts of our website may not function properly or as well as they otherwise might;</p></li>

    <li><p>changes will apply across all websites which you visit (unless you choose to block cookies only from particular websites); and</p></li>

    <li><p>the settings which you change will only apply on the device on which you change the settings and will not apply across all other devices which you use.</p></li>
    </ul>

    <h2 id="4specificdetails">4. Specific details</h2>

    <p>We have set out below details of each of the cookies on our site, a description of what they do and where relevant, external links which provide more information about them:</p>

    <ul>
    <li><p>Google Analytics</p>

    <p>We use Google Analytics to analyse the use of this website. Google Analytics generates statistical and other information about website use by means of cookies, which are stored on users' computers. The information generated relating to our website is used to create reports about the use of the website. Google will store this information.</p>

    <p>Google's privacy policy is available <a href="https://policies.google.com/privacy">here</a>.</p></li>
    </ul>

    </div>
</template>

<script>
export default {
  name: "CookiesView",
};
</script>
